var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEarthSystemsScience(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 216 216",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round;stroke-width:6px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M151.41,122.2A14.28,14.28,0,0,0,154,114c0-8.4-7.34-15.21-16.4-15.21a17.83,17.83,0,0,0-5,.7c-5.16-12.55-14.36-20.9-24.85-20.9-13.83,0-25.42,14.52-28.47,34a23.21,23.21,0,0,0-2.37-.12c-13.14,0-23.79,9.89-23.79,22.08S63.83,156.63,77,156.63a25.2,25.2,0,0,0,10.39-2.22C92.64,162.2,99.85,167,107.81,167c9.08,0,17.2-6.27,22.57-16.1a62.72,62.72,0,0,0,10.6.88c17.45,0,31.59-6.81,31.59-15.22C172.57,129.92,163.74,124.28,151.41,122.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M176.29,73.4,196.2,90l-19,16.78M72.36,90.09H193.71"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M46.57,65.64,36.33,55.41m0,79,10.24-10.23m58.56-58.57,10.24-10.23M34.45,94.92H20m55.89-41.4V39M59.77,118.59a28.82,28.82,0,1,1,40.58-39.4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEarthSystemsScience);
export default __webpack_public_path__ + "static/media/EARTH_SYSTEMS_SCIENCE.946b028933e4a57afaa29ffa0f1d46ae.svg";
export { ForwardRef as ReactComponent };